// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

const transformAuctionStatus = (auctionStatus: string, currentItem: any) => {
    if (auctionStatus === 'LOADED') {
        return 'online';
    } else if (auctionStatus === 'OPN') {
        return 'live';
    } else if (auctionStatus === 'PAUSED' || auctionStatus === 'MOVED') {
        return 'paused';
    } else {
        return currentItem.LotId ? 'live' : 'online';
        // return 'notLoaded';
    }
};

export const transformLotStatus = (lotStatus: string, currentItem: any) => {
    if (lotStatus === 'OPN') {
        return 'open';
    } else if (
        lotStatus === 'CLSD' ||
        lotStatus === 'SOLD' ||
        lotStatus === 'PASS' ||
        lotStatus === 'SKIP' ||
        lotStatus === 'UNSLD'
    ) {
        return 'closed';
    } else {
        return currentItem.LotId ? 'open' : 'closed';
    }
};

const transformPost = body => {
    const {
        Approved: approved,
        Auction: catalog,
        // TODO: get the current status from the response rather than relying on the current item's existence
        // Status: status,
    } = body.data;

    const {
        AuctionDescription: description,
        AuctionId: catalogId,
        AuctionTitle: title,
        CurrentLot: currentItem,
        LastUpdated: lastUpdated,
        LotCount: itemCount,
        ServerID: shim,
    } = catalog || {};

    const {
        AskPrice: askPrice,
        auctionStatus,
        HighBid: leadingBid,
        HighEstimate: highEstimate,
        Increment: increment,
        Index: itemIndex,
        leadingAssignedId,
        LeadingBidderId: leadingBidder,
        LotDescription: lotDescription,
        LotId: itemId,
        LotNumber: lotNumber,
        LotStatus,
        LotTitle: lotTitle,
        LowEstimate: lowEstimate,
        ReservePrice: reserverPrice,
    } = currentItem || {};

    return {
        data: {
            approved,
            catalogId,
            currentItem: {
                askPrice,
                highEstimate,
                increment: increment || 1,
                itemId,
                itemIndex,
                leadingAssignedId,
                leadingBid,
                leadingBidder,
                lotDescription,
                lotNumber,
                lotStatus: transformLotStatus(LotStatus, currentItem),
                lotTitle,
                lowEstimate,
                reserverPrice,
            },
            description,
            itemCount,
            lastUpdated,
            shim,
            status: transformAuctionStatus(auctionStatus, currentItem),
            title,
        },
    };
};

const transform = body => {
    return JSON.parse(body.text);
};

const transformGet = body => {
    const data = body.data || {};

    const {
        Approved: approved,
        AuctionDescription: description,
        AuctionId: catalogId,
        AuctionTitle: title,
        CurrentLot,
        LastUpdated: lastUpdated,
        LotCount: itemCount,
        ServerID: shim,
        // Status: status,
    } = data;

    const currentItem = CurrentLot || {};

    const {
        AskPrice: askPrice,
        auctionStatus,
        HighBid: leadingBid,
        HighEstimate: highEstimate,
        Increment: increment,
        Index: itemIndex,
        leadingAssignedId,
        LeadingBidderId: leadingBidder,
        LotDescription: lotDescription,
        LotId: itemId,
        LotNumber: lotNumber,
        LotStatus,
        LotTitle: lotTitle,
        LowEstimate: lowEstimate,
        ReservePrice: reserverPrice,
    } = currentItem;

    return {
        data: {
            approved,
            catalogId,
            currentItem: {
                askPrice,
                highEstimate,
                increment: increment || 1,
                itemId,
                itemIndex,
                leadingAssignedId,
                leadingBid,
                leadingBidder,
                lotDescription,
                lotNumber,
                lotStatus: transformLotStatus(LotStatus, currentItem),
                lotTitle,
                lowEstimate,
                reserverPrice,
            },
            description,
            itemCount,
            lastUpdated,
            shim,
            status: transformAuctionStatus(auctionStatus, currentItem),
            title,
        },
    };
};

type FetchLiveCatalogStatusParams = {
    authToken: string,
    bidderId: number,
    catalogId: number,
    deployment: string,
    email: string,
    source: string,
};

type FetchLiveCatalogStatusFromPubnubParams = {
    channel: string,
    subscribeKey: string,
};

export default {
    fetchLiveCatalogStatus: ({
        authToken: Token,
        bidderId,
        catalogId: AuctionId,
        deployment,
        email: Email,
        source: Source,
    }: FetchLiveCatalogStatusParams) =>
        new Promise<any>((resolve, reject) => {
            const shouldPost = bidderId !== -1 && bidderId !== 0;
            const requestFuction = shouldPost ? makePost : makeGet;
            const request = requestFuction({
                authToken: Token,
                deployment,
                path: `<CLERK-SERVICE>clerk/auction/${AuctionId}`,
            });

            if (shouldPost) {
                request.send({
                    AuctionId,
                    Email,
                    Source,
                    Token,
                });
            }

            request.end((err, response) =>
                handleResponseOld({
                    err,
                    reject,
                    resolve,
                    response,
                    success404: true,
                    transform: shouldPost ? transformPost : transformGet,
                }),
            );
        }),
    fetchLiveCatalogStatusFromPubnub: ({ channel, subscribeKey }: FetchLiveCatalogStatusFromPubnubParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                path: `<PUBNUB-API>${subscribeKey}/channel/${channel}`,
            });

            request.end((err, response) =>
                handleResponseOld({
                    err,
                    reject,
                    resolve,
                    response: { body: response },
                    transform,
                }),
            );
        }),
};
